import { pxToRem, themeGetColor } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const PageContainer = styled.div `
  display: flex;
  flex-direction: row;
  height: 100vh;
  justify-content: flex-start;
  width: 100%;
  overflow: hidden;

  background-color: ${themeGetColor('background.100', 0.5)};
`;
export const Content = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  background-color: ${themeGetColor('background.50')};

  border-left: ${pxToRem(1)} solid ${themeGetColor('border.100')};
`;
